import { render } from "./myProfile.vue?vue&type=template&id=bc15c7bc&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"

import "./myProfile.vue?vue&type=style&index=0&id=bc15c7bc&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc15c7bc"]])

export default __exports__